module.exports = __webpack_public_path__ + "static/assets/351b607f91e31cb4b00f142e376a1bba.svg";